import React, { useEffect, useState } from "react";
import "./styles/dashboard.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CommonHeader from "./components/CommonHeader";

const Dashboard = () => {
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [showAccessModal, setShowAccessModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userPages, setUserPages] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleDeleteUser = (userId, userName) => {
    if (window.confirm(`Are you sure you want to delete user "${userName}"?`) === false) {
      return false;
    }

    const data = new URLSearchParams();
    data.append('user_id', userId);
    
    fetch(`${process.env.REACT_APP_API_URL}/user/deleteuser`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: data,
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);

      if (resp.message === "OK" || resp.message === "Deleted") {
        toast.success("User deleted successfully");
        // Refresh the users list
        fetch(`${process.env.REACT_APP_API_URL}/user/getlist`, {
          method: "post",
          headers: {
            Authorization: localStorage.getItem("token"),
          },
          body: [],
        }).then(async (res) => {
          let resp = await res.json();
          if (resp.message === "OK") {
            setUsers(resp.list);
          } else {
            toast.error(resp.message);
          }
        });
      } else {
        toast.error(resp.message);
      }
    });
  };

  const handleManageAccess = (user) => {
    setSelectedUser(user);
    setLoading(true);
    
    const data = new URLSearchParams();
    data.append('user_fk', user.user_id);
    
    fetch(`${process.env.REACT_APP_API_URL}/user/getUserPageAccess`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: data,
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);
      
      if (resp.message === "OK") {
        setUserPages(resp.list);
        setShowAccessModal(true);
      } else {
        toast.error(resp.message);
      }
      setLoading(false);
    }).catch(error => {
      console.error('Error fetching user page access:', error);
      toast.error('Failed to load user access data');
      setLoading(false);
    });
  };

  const handleAccessToggle = (pageId, currentStatus) => {
    const newStatus = currentStatus === 1 ? 0 : 1;
    
    const data = new URLSearchParams();
    data.append('user_fk', selectedUser.user_id);
    data.append('page_fk', pageId);
    data.append('status', newStatus);
    
    fetch(`${process.env.REACT_APP_API_URL}/user/updatePageAccess`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: data,
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);
      
      if (resp.message === "OK" || resp.status === 1) {
        // Update the local state to reflect the change
        setUserPages(prevPages => 
          prevPages.map(page => 
            page.page_id === pageId 
              ? { ...page, user_access_status: newStatus }
              : page
          )
        );
        toast.success('Access updated successfully');
      } else {
        toast.error(resp.message || 'Failed to update access');
      }
    }).catch(error => {
      console.error('Error updating page access:', error);
      toast.error('Failed to update access');
    });
  };

  const closeAccessModal = () => {
    setShowAccessModal(false);
    setSelectedUser(null);
    setUserPages([]);
  };

  useEffect(() => {

    fetch(`${process.env.REACT_APP_API_URL}/user/getlist`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: [],
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);

      if (resp.message === "OK") {
        setUsers(resp.list);
      } else {
        toast.error(resp.message);
      }
    });
  }, []);

  return (
    <>
      <div class="d-flex flex-column flex-lg-row h-lg-full bg-surface-secondary">
        <div class="h-screen flex-grow-1 overflow-y-lg-auto">
          <CommonHeader />

          <main class="py-6 bg-surface-secondary">
            <div class="container-fluid">
              <div class="card shadow border-0 mb-7">
                <div class="card-header">
                  <h5 class="mb-0">Users</h5>
                </div>
                <div class="table-responsive">
                  <table class="table table-hover table-nowrap">
                    <thead class="thead-light">
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Mob Number</th>
                        <th scope="col">Role</th>
                        <th scope="col">Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {users != []
                        ? users.map((user) => {
                            return (
                              <tr>
                                <td>{user.user_name}</td>
                                <td>{user.email}</td>
                                <td>
                                  {"(" + user.country_code + ")"}{" "}
                                  {user.mobile_no}
                                </td>
                                <td>{user.user_role_name}</td>
                                <td>
                                  <span class="badge badge-lg badge-dot">
                                    {user.status === '0' ? (
                                      <>
                                        
                                        <i
                                          style={{ backgroundColor: "gray" }}
                                        ></i>
                                        {'Inactive'}
                                      </>
                                    ) : (
                                      <>
                                        
                                        <i className="bg-success"></i>
                                        {'Active'}
                                      </>
                                    )}
                                  </span>
                                </td>
                                <td class="text-end">
                                  <button
                                    onClick={()=>{
                                      navigate(`/user/edit/${user.user_id}`)

                                      localStorage.setItem("name", `${user.user_name}`);
                                  
                                      localStorage.setItem("email", `${user.email}`);
                                      localStorage.setItem("number", `${user.mobile_no}`);
                                      localStorage.setItem("countryCode", `${user.country_code}`);
                                      localStorage.setItem("role", `${user.user_role_name}`);
                                      localStorage.setItem("status", `${user.status}`);
                                  
                                    }
                                  }
                                    class="btn btn-sm btn-neutral"
                                    style={{ marginRight: "0.5rem" }}
                                  >
                                    Edit
                                  </button>
                                  <button
                                    onClick={() => handleManageAccess(user)}
                                    class="btn btn-sm btn-info"
                                    style={{ marginRight: "0.5rem" }}
                                    disabled={loading}
                                  >
                                    <i class="bi bi-shield-check me-1"></i>
                                    Access
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-sm btn-square btn-neutral text-danger-hover"
                                    onClick={() => handleDeleteUser(user.user_id, user.user_name)}
                                    title="Delete User"
                                  >
                                    <i class="bi bi-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        : ""}
                    </tbody>
                  </table>
                </div>
                <div class="card-footer border-0 py-5">
                  <button
                    class="btn d-inline-flex btn-sm btn-primary mx-1"
                    onClick={() => {
                      navigate("/user/add");
                    }}
                  >
                    <span class=" pe-2">
                      <i class="bi bi-plus"></i>
                    </span>
                    <span>Add User</span>
                  </button>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Access Management Modal */}
      {showAccessModal && (
        <div class="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  Manage Access for {selectedUser?.user_name}
                </h5>
                <button 
                  type="button" 
                  class="btn-close" 
                  onClick={closeAccessModal}
                ></button>
              </div>
              <div class="modal-body">
                {loading ? (
                  <div class="text-center">
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div class="table-responsive">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th>Page Name</th>
                          <th>Page URL</th>
                          <th class="text-center">Access</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userPages.map((page) => (
                          <tr key={page.page_id}>
                            <td>{page.page_name}</td>
                            <td>
                              <small class="text-muted">{page.page_url}</small>
                            </td>
                            <td class="text-center">
                              <div class="form-check d-flex justify-content-center">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id={`page-${page.page_id}`}
                                  checked={page.user_access_status == '1'}
                                  onChange={() => handleAccessToggle(page.page_id, page.user_access_status)}
                                />
                                <label class="form-check-label ms-2" for={`page-${page.page_id}`}>
                                  {page.user_access_status == '1' ? 'Granted' : 'Denied'}
                                </label>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div class="modal-footer">
                <button 
                  type="button" 
                  class="btn btn-secondary" 
                  onClick={closeAccessModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
